<template>
  <div class="expert-review">
    <div class="position-relative pt-0 my-md-3 pb-0 ">
      <div class="container hk-container-padding py-5">
        <div class="row ">
          <!-- Heading Section -->
          <div class="col-12 order-1 text-center">
            <div class="position-relative hk-z-index m-text-center d-flex flex-column justify-content-center align-items-center min-vh-50">
              <h2 class="hk-heading">
                {{ $t('rating_section.what_expert_says') }}
              </h2>
              <h3 class="hk-subbody-bold ">Hotelkey Review - Everything you must know about us</h3>
              <p></p>
            </div>
          </div>

          <!-- Images Section -->
          <div class="col-12 col-md-12 my-auto order-2 d-flex justify-content-center pt-3 pb-5">
            <div class="d-flex justify-content-between exp-img-wrapper">
              <div class="exp-img-container">
                <img src="@/assets/expert-review/getapp_leader.svg" alt="getapp" loading="lazy" class="w-100 exp-img" />
              </div>
              <div class="exp-img-container">
                <img src="@/assets/expert-review/capterra_shortlist.svg" alt="capterra" loading="lazy" class="w-100 exp-img" />
              </div>
              <div class="exp-img-container">
                <img src="@/assets/expert-review/expidia.png" alt="expidia" loading="lazy" class="w-100 exp-img" />
              </div>
            </div>
          </div>


        </div>
<!-- Review Box container -->
<div class="reviews-container">
  <a href="https://www.getapp.com/hospitality-travel-software/a/hotelkey/" class="clickable-box border mb-0" target="_blank">
    <div class="content-box">
      <img src="@/assets/expert-review/getaap.svg" alt="Centered Image" class="center-img" />
      <div class="stars">
        <span v-for="n in 5" :key="n" class="star">★</span>
      </div>
      <p class="review-text">4.7/5</p>
      <p class="know-more">Explore More</p>
    </div>
  </a>
  <a href="https://www.softwareadvice.com/hotel-management/hotelkey-profile/" class="clickable-box border mb-0" target="_blank">
    <div class="content-box">
      <img src="@/assets/expert-review/we-rated.svg" alt="Centered Image" class="center-img" />
      <div class="stars">
        <span v-for="n in 5" :key="n" class="star">★</span>
      </div>
      <p class="review-text">4.7/5</p>
      <p class="know-more">Explore More</p>
    </div>
  </a>
  <a href="https://hoteltechreport.com/operations/property-management-systems/hotelkey-pms" class="clickable-box border mb-0" target="_blank">
    <div class="content-box">
      <img src="@/assets/expert-review/hotel-tech.svg" alt="Centered Image" class="center-img" />
      <div class="stars">
        <span v-for="n in 5" :key="n" class="star">★</span>
      </div>
      <p class="review-text">4.5/5</p>
      <p class="know-more">Explore More</p>
    </div>
  </a>
  <a href="https://www.capterra.com/p/198632/HotelKey-PMS/reviews/" class="clickable-box border mb-0" target="_blank">
    <div class="content-box">
      <img src="@/assets/expert-review/captera.svg" alt="Centered Image" class="center-img" />
      <div class="stars">
        <span v-for="n in 5" :key="n" class="star">★</span>
      </div>
      <p class="review-text">4.7/5</p>
      <p class="know-more">Explore More</p>
    </div>
  </a>
</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheExperts"
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

.expert-review {
  position: relative;
  background: $bg-secondary;
}

.review-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 150px;
  border-radius: 15px;
  padding: 1rem;
    margin-right: 50px;
  background: #ffffff;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease-in-out;

  img {
    width: 100px;
    margin-bottom: 10px;
  }

  span {
    font-size: 12px;
    background: $bg-secondary;
    padding: 5px 10px;
    border-radius: 10px;
    font-weight: 700;
  }

  &:hover {
    transform: scale(1.05);
  }
}

.exp-img-container {
  width: 6rem;
  margin: 0 10px;
}

.exp-img {
  width: 100%;
}

.review-button-div {
  padding: 2rem 0;

  button {
    padding: 0.4rem 0.5rem;
    border: 1px solid #3D4550;
    border-radius: 19px;
    color: #3D4550;
    font-weight: 500;
  }
}
.reviews-container {
        display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    /* align-content: stretch; */
    align-items: center;
    gap: 1rem;
}

.clickable-box {
  flex: 0 0 23%; /* Adjust width as needed (23% for 4 items in a row) */
  margin-bottom: 20px; /* Space below each item */
}

.content-box {
  /* Additional styles for content-box if needed */
  text-align: center; /* Center-align text */
}
.clickable-box {
  display: block;
  width: 300px;
  background-color: rgb(255, 255, 255);
  padding: 20px;
  color: white;
  text-align: center;
  text-decoration: none;
  border-radius: 10px; /* Optional: rounded corners */
}

.content-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.center-img {
     width: 100px;
    height: 50px;
    
    object-fit: fill;
    margin-bottom: 0px;
}

.stars {
  color: gold;
  font-size: 20px;
}

.review-text {
  margin: 10px 0;
  font-size: 16px;
}

.explore-more {
  font-size: 18px;
  font-weight: bold;
  margin-top: 10px;
  cursor: pointer;
  transition: color 0.3s;
  color: $hk-blue;
}




/* Hover effect on the entire box */
.clickable-box:hover {
  background-color: #ffffff;
  transform: scale(1.05); /* Slightly enlarge the box */
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.19);
}

@media (max-width: 575.98px) {
  .expert-review {
    padding: 1rem 0.5rem;
  }

  .hk-heading-text {
    font-size: 1.5rem;
    line-height: 1.2;
    font-weight: 800;
  }

  .review-list {
    width: 100px;
    height: 100px;

    img {
      width: 60px;
    }

    span {
      font-size: 10px;
    }
  }
  .reviews-container {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    /* align-content: stretch; */
    align-items: center;
    gap: 1rem;
    justify-content: center;}

  .exp-img-container {
    width: 80px;
    margin: 0 5px;
  }
}
</style>
